import React from 'react'

function Footer() {
    return (
        <>
            <div className="Footer2">
                <div className="container text-center">
                    <div className="Footer-Paragraph py-4 text-xs font-semibold sm:text-lg">
                        <p>Copyright &copy; 2023 by Noman. | All Rights Reserved.</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Footer
